import domReady from '@wordpress/dom-ready';

import MicroModal from 'micromodal';

const setupPopupSlider = () => {
	if (document.querySelector('.wp-block-goldencat-popup')) {
		MicroModal.init();
	}

	// // Add the close btn in the popup
	// document
	// 	.querySelectorAll('.wp-block-goldencat-popup-wrapper')
	// 	?.forEach((popupContainer) => {
	// 		// eslint-disable-next-line no-console
	// 		console.log(popupContainer.querySelector('.modal__close'));
	// 		popupContainer
	// 			.querySelector('.wp-block-goldencat-popup')
	// 			?.prepend(popupContainer.querySelector('.modal__close'));
	// 	});

	if (document.querySelector('.modal.modal-auto-open')) {
		const autoOpenModal = Array.from(
			document.querySelectorAll(
				'.wp-block-goldencat-popup-wrapper .modal.modal-auto-open'
			)
		)?.map((popup) => popup.getAttribute('id'));

		const displayNextModal = () => {
			if (autoOpenModal.length > 0) {
				MicroModal.show(autoOpenModal.shift(), autoOpenConfig);
			}
		};

		const autoOpenConfig = {
			onShow: (modal) => {
				// displayNextModal
				/* eslint-disable no-console */
				console.info(`${modal.id} is shown`);
				/* eslint-enable no-console */
			}, // [1]
			onClose: displayNextModal, // [2]
		};

		displayNextModal();
	}
};

domReady(() => setupPopupSlider());
